import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  baseBoxShadowFocus,
  borderRadius8,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import {
  grey1,
  grey2,
  grey3,
  grey4,
  grey6,
  grey9,
  purple7,
} from 'approot/shared/styles/colours.style';
import {
  fontSize12,
  fontSize16,
  fontWeightMedium,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import {
  spacing12,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { PRESENT_COMPONENT_RESPONSE_Z_INDEX } from 'approot/activity-builder/present/activity-builder-present.constants';
import { TooltipWrapperStyled } from 'approot/shared/tooltip/tooltip.style';

export const ComponentOverlayWrapper = styled.div`
  position: relative;
`;

export const ComponentOverlayButton = styled.div`
  ${boxShadowBlack12}
  background-color: ${grey1};
  border-radius: ${rem(64)};
  border: 1px solid ${grey1};
  align-items: center;
  display: inline-flex;
  font-size: ${rem(fontSize16)};
  font-weight: ${fontWeightNormal};
  gap: ${rem(spacing4)};
  height: ${rem(40)};
  padding: 0 ${rem(spacing12)};

  &:hover {
    background-color: ${grey3};
    border-color: ${grey6};
    cursor: pointer;
  }
`;

export const ComponentOverlayBadge = styled.div`
  background-color: ${grey3};
  border-radius: ${rem(32)};
  color: ${grey9};
  align-items: center;
  display: inline-flex;
  font-size: ${rem(fontSize12)};
  font-weight: ${fontWeightNormal};
  gap: ${rem(spacing4)};
  padding: ${rem(spacing4)} ${rem(spacing8)};
  position: absolute;
  right: ${rem(spacing8)};
  top: -${rem(spacing12)};
`;

type ComponentOverlayProps = {
  $noBackground?: boolean;
  $borderRadius?: boolean;
  $isLoading?: boolean;
};
export const ComponentOverlay = styled.button<ComponentOverlayProps>`
  background-color: ${({ $isLoading }) =>
    $isLoading ? 'rgba(0, 0, 0, 0.2)' : 'transparent'};
  border-radius: ${({ $borderRadius = true }) =>
    $borderRadius ? rem(borderRadius8) : 0};
  border: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
  position: absolute;
  z-index: ${PRESENT_COMPONENT_RESPONSE_Z_INDEX};

  &:hover {
    ${({ $isLoading }) =>
      !$isLoading &&
      css`
        outline: 1px solid ${grey6};
        outline-offset: 2px;
        cursor: pointer;
      `}
  }

  &:focus {
    outline: none;
    box-shadow: inset ${baseBoxShadowFocus};
  }
`;

export const ComponentOverlayTooltip = styled.div`
  ${TooltipWrapperStyled} {
    position: absolute;
    inset: 0;
  }
`;

type ComponentOverlayIndicatorProps = {
  $isVisible: boolean;
};
export const ComponentOverlayIndicator = styled.div<
  ComponentOverlayIndicatorProps
>`
  ${flexCentreAlignCss}
  background-color: ${({ $isVisible }) => ($isVisible ? purple7 : grey2)};
  border-radius: ${rem(16)};
  border: 1px solid  ${({ $isVisible }) => ($isVisible ? purple7 : grey4)};
  color: ${({ $isVisible }) => ($isVisible ? grey1 : grey6)};
  font-size: ${rem(fontSize12)};
  font-weight: ${fontWeightMedium};
  height: ${rem(16)};
  width: ${rem(16)};
  transition: all 0.3s ease;
`;
